import { render, staticRenderFns } from "./OrderableRequestedDelivery.vue?vue&type=template&id=8b00cb14&"
import script from "./OrderableRequestedDelivery.vue?vue&type=script&lang=ts&"
export * from "./OrderableRequestedDelivery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports